/**
 * Admins follow their role preset like everyone else, but can never lose access to the
 * settings — otherwise an admin could lock the company out of Rollen & Rechte.
 * Shared by server resolve and the settings UI preview.
 */
export const ADMIN_LOCKED_CAPABILITY_KEYS = [
  'web.einstellungen.view',
  'web.einstellungen.edit',
  'web.einstellungen.invite',
] as const;

export function isAdminLockedCapability(key: string): boolean {
  return (ADMIN_LOCKED_CAPABILITY_KEYS as readonly string[]).includes(key);
}
